<template>
    <v-card>
      <v-card-title class="dialog-header">
        <span class="headline">{{ $t("addUnit") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          text
          icon
          @click="handleClose()"
          valid="false"
          v-shortkey="['esc']"
          @shortkey.native="handleClose()"
        >
        <span class="white--text">
          <v-icon dark>
            mdi-close
          </v-icon>
        </span>
        </v-btn>
      
        </v-card-title>
          <v-card-text>

            <v-form v-model="valid" ref="formCategory">
              <v-container>
                  <v-row :no-gutters="$vuetify.breakpoint.mobile">
                    <v-col cols="8">
                      <v-text-field
                        v-model="formDoc.actual_name"
                        :label="$t('name') + '*'"
                        :rules="valueRules"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="8">
                      <v-text-field
                        v-model="formDoc.short_name"
                        :label="$t('shortName') + '*'"
                        :rules="valueRules"
                        required
                        outlined
                        
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="8">
                        <v-radio-group
                          v-model="formDoc.allow_decimal"
                          row
                          :label="$t('allowDecimal') + '*'"
                          :rules="valueRules"
                          required
                          style="margin-top:-10px !important"
                        >
                          <v-radio label="No" name="allowDecimal" value="no"></v-radio>
                          <v-radio label="Yes" name="allowDecimal" value="yes"></v-radio>
                        </v-radio-group>
                    </v-col>

                    <v-col cols="8">
                      <div style="text-align: right">

                          <v-btn color="default" outlined text @click="handleClose()">
                              {{ $t('close') }}
                          </v-btn>
                          <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
                              <font-awesome-icon icon="check-circle" class="mr-1"/>
                              {{ $t('save') }}
                          </v-btn>         
                      </div>
                    </v-col>
                </v-row>
              </v-container>
            </v-form>

          </v-card-text>
    </v-card>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";

export default {
  name: "unit",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      formDoc: {
        id: "",
        actual_name: "",
        short_name: "",
        allow_decimal: "no",
        contact_id: this.$store.state.userDoc.contact_id,
        eco_business: 'out_side',
      },

    };
  },

  mounted() {
    if(this.$store.state.outsideBusiness.dialog && this.$store.state.outsideBusiness.dialog_type == 'unit'){
      this.fetchParentCategory();
      this.fetchTransactionUnit({search: '', limit: this.noLimit, offset: this.currentPage});
    }
  },

  methods: {
    reset() {
      let vm = this;
      if (vm.$refs.formCategory) {
          vm.$refs.formCategory.resetValidation();
          vm.formDoc.id           = "";
          vm.formDoc.actual_name   = "";
          vm.formDoc.short_name    = "";
          vm.formDoc.allow_decimal = "no";
      }
      this.$store.dispatch('updateOutsideBusinessProduct', {});

    },

    async handleClose(){
        await this.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'})
        this.reset();
    },

    async submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formCategory.validate()) {
          vm.overlay = true;

          let url = provider.baseURL + provider.storeUnit;

          return new Promise((resolve, reject) => {
              axios.post(url, this.formDoc, {headers: {
                Authorization: localStorage.token,
                "Content-Type": "multipart/form-data"
                }}).then(
                  res => {
                      if (res.data.response && res.data.response.code === 200) {
                          vm.$notify({
                              title: "Success",
                              message: vm.$t("success"),
                              type: "success",
                              duration: 700
                          });

                          vm.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'});
                          this.$nextTick(() => {
                            vm.reset();
                          })
                      }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    }
  },

  computed:{},
  watch: {}
  
};
</script>